(function(){
  const qs=(root,sel)=>root.querySelector(sel);
  const qsa=(root,sel)=>Array.from(root.querySelectorAll(sel));

  qsa(document,'[data-slider]').forEach((slider)=>{
    const track=qs(slider,'[data-slider-track]');
    if(!track) return;
    const slides=qsa(track,'[data-slide]');
    const dots=qsa(slider,'[data-slider-dot]');
    const prev=qs(slider,'[data-slider-prev]');
    const next=qs(slider,'[data-slider-next]');
    let index=0;
    let timer=null;

    const isHero=slides.length>0;
    const showHero=(i)=>{
      if(!isHero) return;
      index=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>s.classList.toggle('is-active',n===index));
      dots.forEach((d,n)=>{ d.classList.toggle('is-active',n===index); d.setAttribute('aria-selected', n===index ? 'true' : 'false'); });
    };
    const scrollByCard=(direction)=>{
      const first=track.children[0];
      const amount=first ? first.getBoundingClientRect().width + 18 : track.clientWidth * .85;
      track.scrollBy({left: amount * direction, behavior:'smooth'});
    };
    prev && prev.addEventListener('click',()=> isHero ? showHero(index-1) : scrollByCard(-1));
    next && next.addEventListener('click',()=> isHero ? showHero(index+1) : scrollByCard(1));
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>showHero(i)));

    if(isHero && slider.dataset.sliderAutoplay === 'true' && slides.length>1){
      const interval=parseInt(slider.dataset.sliderInterval || '5000',10);
      const start=()=>{timer=setInterval(()=>showHero(index+1),interval)};
      const stop=()=>{if(timer) clearInterval(timer)};
      start();
      slider.addEventListener('mouseenter',stop);
      slider.addEventListener('mouseleave',start);
    }

    let startX=0;
    let endX=0;
    slider.addEventListener('touchstart',(e)=>{startX=e.changedTouches[0].screenX},{passive:true});
    slider.addEventListener('touchend',(e)=>{
      endX=e.changedTouches[0].screenX;
      if(Math.abs(endX-startX)<40) return;
      if(isHero){showHero(index + (endX<startX ? 1 : -1));}
    },{passive:true});
  });
})();


// Universal back-to-top button
(() => {
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;
  const update = () => button.classList.toggle('is-visible', window.scrollY > 520);
  window.addEventListener('scroll', update, { passive: true });
  button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  update();
})();

// v0.6 working mobile menu drawer
(() => {
  const toggle = document.querySelector('[data-drawer-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  const closeButton = document.querySelector('[data-drawer-close]');
  if (!toggle || !drawer || !overlay) return;

  let previousFocus = null;
  const openDrawer = () => {
    previousFocus = document.activeElement;
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');
    window.requestAnimationFrame(() => closeButton?.focus());
  };
  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    window.setTimeout(() => { overlay.hidden = true; }, 250);
    previousFocus?.focus?.();
  };

  toggle.addEventListener('click', openDrawer);
  closeButton?.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();

// Footer: all columns visible on desktop, one accordion open at a time on mobile.
(() => {
  const MOBILE_BREAKPOINT = 989;

  const initialiseFooterAccordions = (scope = document) => {
    const accordions = Array.from(scope.querySelectorAll('.footer-accordion'));
    if (!accordions.length) return;

    const syncState = () => {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        accordions.forEach((item) => { item.open = true; });
        return;
      }

      const openItems = accordions.filter((item) => item.open);
      if (openItems.length > 1) {
        accordions.forEach((item, index) => { item.open = index === 0; });
      }
    };

    accordions.forEach((item) => {
      if (item.dataset.footerAccordionReady === 'true') return;
      item.dataset.footerAccordionReady = 'true';
      item.addEventListener('toggle', () => {
        if (window.innerWidth > MOBILE_BREAKPOINT) {
          item.open = true;
          return;
        }
        if (!item.open) return;
        accordions.forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    syncState();
    window.addEventListener('resize', syncState, { passive: true });
  };

  initialiseFooterAccordions();
  document.addEventListener('shopify:section:load', (event) => initialiseFooterAccordions(event.target));
})();


// Mobile bottom navigation: reliable links, current-page state, and touch feedback.
(() => {
  const nav = document.querySelector('.mobile-bottom-nav');
  if (!nav) return;
  const links = Array.from(nav.querySelectorAll('a[href]'));
  const currentPath = (window.location.pathname || '/').replace(/\/$/, '') || '/';

  links.forEach((link) => {
    let targetPath = '/';
    try { targetPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/'; } catch (_) {}
    const isHome = targetPath === '/' && currentPath === '/';
    const isCollection = targetPath.includes('/collections') && currentPath.includes('/collections');
    const isExact = targetPath !== '/' && targetPath === currentPath;
    link.classList.toggle('is-active', isHome || isCollection || isExact);
    link.addEventListener('touchstart', () => link.classList.add('is-pressed'), { passive: true });
    ['touchend','touchcancel'].forEach((eventName) => link.addEventListener(eventName, () => link.classList.remove('is-pressed'), { passive: true }));
  });
})();


// Load secondary product images only when a desktop user actually requests the hover state.
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const loadHoverImage = (card) => {
    const image = card.querySelector('[data-hover-image]');
    if (!image || image.dataset.loaded === 'true') return;
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;
    image.dataset.loaded = 'true';
  };
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    card.addEventListener('pointerenter', () => loadHoverImage(card), { once: true, passive: true });
    card.addEventListener('focusin', () => loadHoverImage(card), { once: true });
  });
})();
